import styled from 'styled-components'
import {background, border, color, flexbox, grid, layout, position, shadow, space, typography} from 'styled-system'
import shouldForwardProp from '@styled-system/should-forward-prop'

import sx from '@fuegokit/react/sx'
import {ComponentProps} from '@fuegokit/react/utils/types'
import {FuegoBoxProps} from './types'

/**
 * The Box component is a low-level, composable, abstract theme-aware utility component. It applies CSS properties directly via its props.
 *
 */
const Box = styled.div.withConfig<FuegoBoxProps>({
  shouldForwardProp: (prop, defaultValidatorFn) => shouldForwardProp(prop) && defaultValidatorFn(prop)
})`
  ${space}
  ${typography}
  ${layout}
  ${color}
  ${flexbox}
  ${grid}
  ${background}
  ${border}
  ${position}
  ${shadow}
  ${sx}
`

export default Box

export type BoxProps = ComponentProps<typeof Box>
